import { useCallback } from 'react';
import { Field as ApiField } from 'api/tasks';
import { useGetSprintConfiguration } from 'queries/sprint-planning';
import { Field } from 'stores/fields';
import { AccountFeature, useAccountFeature } from './use-account-feature';

export const useFilterPointsFieldsFromTaskFields = () => {
  const { data: sprintConfig } = useGetSprintConfiguration();

  const [isSprintPlaningFeatureEnabled] = useAccountFeature(
    AccountFeature.SprintPlanning,
  );

  const { pointType: selectedPointType, pointsEnabled } = sprintConfig ?? {};
  const filterPointsFieldsFromTaskFields = useCallback(
    (fields: (ApiField | Field)[]): (ApiField | Field)[] => {
      return fields.reduce((acc, field) => {
        if (!sprintConfig || !pointsEnabled || !isSprintPlaningFeatureEnabled) {
          if (!field.metaData?.pointType) {
            acc.push(field);
          }
        } else {
          if (
            field.metaData?.pointType &&
            field.metaData?.pointType !== selectedPointType &&
            pointsEnabled
          ) {
            return acc;
          }

          if (field.metaData?.pointType) {
            acc.push({
              ...field,
              fieldLabel: 'Points',
            });
          } else {
            acc.push(field);
          }
        }

        return acc;
      }, [] as (ApiField | Field)[]);
    },
    [
      isSprintPlaningFeatureEnabled,
      pointsEnabled,
      selectedPointType,
      sprintConfig,
    ],
  );

  return { filterPointsFieldsFromTaskFields };
};
